import React, { Component } from 'react'
import { Grid, Paper, TextField, Typography, Tooltip, InputAdornment, FormControlLabel, Checkbox } from '@material-ui/core';
import POStatusBadge from './POStatusBadge/POStatusBadge';
import LocationSelect from '../LocationSelect';
import SupplierSelect from '../SupplierSelect';
import NewReleases from '@material-ui/icons/NewReleases';

import * as defs from './PurchaseOrder.module.scss'

export default class PurchaseOrderHeading extends Component {

  render() {

    const {
      isEditing,
      purchaseOrder,
      errors = {},
      user,
      onUpdate = null
    } = this.props;

    if (purchaseOrder.contractNumber) {
      purchaseOrder.contractNumber = purchaseOrder.contractNumber.replace('SEL-', '');
    }

    return (

      <Grid item xs={12} md={12}>
        <div style={{padding: '8px 16px 32px'}}>
          <Typography
            variant="h4"
            className={`${defs.title}`}
          >{ purchaseOrder.purchaseOrderNumber || (purchaseOrder.id ? `(Pending order from ${purchaseOrder.supplier ? purchaseOrder.supplier.name : 'supplier'})` : "New purchase order") }</Typography>
          <POStatusBadge purchaseOrder={purchaseOrder} />
          <div className={`${defs.raisedBy}`}>
            { purchaseOrder.user
            ? <Typography style={{display: 'inline-block'}}>Raised by {purchaseOrder.user.name}</Typography>
            : <Typography style={{display: 'inline-block'}}>Raising as {user.name}</Typography>
            }
          </div>
          <div>
            <FormControlLabel
              className={defs.provisionalControlLabel}
              style={{opacity: isEditing ? 1 : 0.5}}
              control={
              <Checkbox variant='outlined'
                disabled={!isEditing}
                onChange={event => onUpdate({isProvisional: event.target.checked})}
                size={'small'}
                checked={purchaseOrder.isProvisional}
                className={defs.provisionalControl} />
              }
              label={<span>Provisional</span>}
            />
            <FormControlLabel
              className={defs.preApprovedControlLabel}
              style={{opacity: isEditing && user.type != 'normal' ? 1 : 0.5}}
              control={
              <Checkbox variant='outlined'
                disabled={!isEditing || user.type === 'normal'}
                onChange={event => onUpdate({isEditsPreApproved: event.target.checked})}
                size={'small'}
                checked={purchaseOrder.isEditsPreApproved}
                className={defs.preApprovedControl} />
              }
              label={<span>Edits Pre-approved</span>}
            />
          </div>
        </div>
        <Paper style={{ padding: '8px 16px 16px', margin: '-8px 16px -20px', maxWidth: '1339px'}}>
          <Typography variant="overline">
            Details
          </Typography>
          <div style={{marginTop: '8px'}} className={defs.headingEntries}>
            <div className={defs.headingEntry}>
              {
                isEditing
                  ? <LocationSelect 
                    initialValue={purchaseOrder.location}
                    onUpdate={(value) => onUpdate({location: value})}
                    error={errors.location}
                  />
                  : <TextField
                    type="text"
                    name="location"
                    label="Location"
                    InputProps={{readOnly: true}}
                    placeholder="Location"
                    value={(purchaseOrder.location) ? purchaseOrder.location.name : 'No location'}
                    fullWidth
                  />
              }
            </div>
            <div className={defs.headingEntry}>
              { isEditing
                ? <SupplierSelect
                  initialValue={purchaseOrder.supplier}
                  onUpdate={(value) => onUpdate({supplier: value})}
                  error={errors.supplier}
                />
                :
                <Tooltip title={
                  [
                    purchaseOrder.supplier.telephone ? `Tel: ${purchaseOrder.supplier.telephone}` : null,
                    purchaseOrder.supplier.email ? `Email: ${purchaseOrder.supplier.email}` : null
                  ].filter(el => el != null).join(' ')
                } arrow>
                  <TextField
                    type="text"
                    name="supplier"
                    label="Supplier"
                    InputLabelProps={{ shrink: true }}
                    readOnly
                    value={(purchaseOrder.supplier) ? purchaseOrder.supplier.name : 'Supplier missing'}
                    // width={100}
                    fullWidth
                  />
                </Tooltip>
              }
            </div>
            <div className={defs.headingEntry}>
              <TextField
                type="text"
                name="contractNumber"
                label="Contract number"
                InputProps={{
                  readOnly: !isEditing,
                  startAdornment: <InputAdornment position="start">SEL-</InputAdornment>,
                }}
                InputLabelProps={{ shrink: true }}
                onChange={event => onUpdate({contractNumber: event.target.value})}
                placeholder="100123"
                value={purchaseOrder.contractNumber || ''}
                fullWidth
              />
            </div>
            <div className={defs.headingEntry}>
              <TextField
                id="date"
                label="Spend date"
                type="date"
                value={purchaseOrder.spendDate}
                {...(!isEditing && { InputProps: { readOnly: true }} )}
                onChange={event => onUpdate({spendDate: event.target.value})}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </div>
            <div className={defs.headingEntry}>
              { purchaseOrder.approvedTs && <TextField
                type="date"
                label="Approved date"
                InputProps={{readOnly: true}}
                value={purchaseOrder.approvedTs}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
              /> }
              { !purchaseOrder.approvedTs && <TextField
                type="text"
                name="approvalDate"
                label="Approved date"
                InputProps={{readOnly: true}}
                value='Not yet approved'
                fullWidth
              />}
            </div>
          </div>
        </Paper>
      </Grid>
    )
  }
}
